import "core-js/modules/es.array.push.js";
import { ElForm, ElFormItem, ElInput, ElButton, ElMessage } from "element-plus";
import 'element-plus/es/components/form/style/css'
import 'element-plus/es/components/form-item/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/message/style/css'

import apiClient from "@/api/apiClient";
export default {
  name: "AuthView",
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton
  },
  data: () => ({
    email: null,
    password: null,
    loading: false
  }),
  methods: {
    async login() {
      this.loading = true;
      try {
        const res = await apiClient.post("login", {
          email: this.email,
          password: this.password
        });
        const {
          accessToken
        } = res.data;
        localStorage.setItem("access_token", accessToken);
        this.$router.push({
          name: "home"
        });
        setTimeout(() => {
          window.location.reload();
        }, 200);
      } catch (e) {
        ElMessage.error(e.message);
        console.log(e.message);
      }
      this.loading = false;
    }
  }
};